module.exports = __webpack_public_path__ + "static/backgroundVideo-35573bafee2c1dc87fae96716cac4f12.png";